import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container } from 'components/layout/Grid/'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getDocuments, deleteDocument } from 'actions/documents'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { hasAccess } from 'utils/hasAccess'
import axios from 'axios'

let source = axios.CancelToken.source()

class DocumentsRemunerations extends Component {
  static propTypes = {
    deleteDocument: PropTypes.func.isRequired,
    documents: PropTypes.object.isRequired,
    getDocuments: PropTypes.func.isRequired,
    routes: PropTypes.arrayOf.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props)
    source = axios.CancelToken.source()
  }

  componentDidMount() {
    const currentUser = (this.props.selectedPartner.EmployeeId && this.props.currentUser.IsAdmin ? this.props.selectedPartner : this.props.currentUser)
    const folder = `${currentUser.userPrincipalName.split('@')[0]}-${currentUser.EmployeeId}`
    const access = hasAccess(this.props.currentUser, 'Tax Statements', this.props.history)
    if (access) {
      this.props.getDocuments('Remunerations', folder, currentUser.EmployeeId, currentUser.userPrincipalName.split('@')[0], source.token)
    }
  }

  componentWillUnmount() {
    if (source) {
      source.cancel('CANCEL_REQUEST')
    }
  }

  handleDeleteDocument = (itemId) => {
    const currentUser = (this.props.selectedPartner.EmployeeId && this.props.currentUser.IsAdmin ? this.props.selectedPartner : this.props.currentUser)
    const folder = `${currentUser.userPrincipalName.split('@')[0]}-${currentUser.EmployeeId}`
    if (itemId) {
      const access = hasAccess(this.props.currentUser, 'Tax Statements', this.props.history, 'RW', false)
      if (access) {
        this.props.deleteDocument(itemId, 'Remunerations', folder, currentUser.EmployeeId, currentUser.userPrincipalName.split('@')[0], source.token)
        // setTimeout(() => { this.props.modalShow(constants.PARTNERPLAN.FORMS.NOTES) }, 500)
        // this.props.getDocuments('Remunerations', folder, source.token)
      } else {
        console.error('You are not authorised to delete document, please contact NPS administrator.')
      }
    }
  }

  render() {
    const { routes, currentUser } = this.props
    const backToAdminCentreText = `${this.props.selectedPartner.Name}: Documents`
    return (
      <div>
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              backToAdminCentreText={backToAdminCentreText}
              currentUser={currentUser}
              documents={this.props.documents}
              getDocuments={this.props.getDocuments}
              handleDeleteDocument={this.handleDeleteDocument}
              setErrorMessage={this.props.setErrorMessage}
            />
          ))}
        </Container>
      </div >
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  documents: state.documents,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getDocuments,
  deleteDocument,
})(DocumentsRemunerations))



// WEBPACK FOOTER //
// ./src/containers/DocumentsRemunerations.js